import { render, staticRenderFns } from "./offerBlock.vue?vue&type=template&id=14fb5ca7&"
import script from "./offerBlock.vue?vue&type=script&lang=js&"
export * from "./offerBlock.vue?vue&type=script&lang=js&"
import style0 from "./offerBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports